import React from 'react';


const AccreditationIcon: React.FC<{color: string, size?: string}> = (props) => {
    let iconSize = (props.size ?? '1.8rem');
    return (
        <div
            className="fa-layers fa-fw"
            style={{fontSize: iconSize, color: props.color}}
        >
            <i className={'fas fa-certificate'}/>
            <div
                className="fa-layers-text fa-inverse"
                data-fa-transform="shrink-6"
                style={{fontWeight: 300}}
            >
                .it
            </div>
        </div>
    );
};

export default AccreditationIcon;